import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import additionalLocationService from "../../../../services/additionalLocationService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/additionalLocationTableColumns";

function AdditionalLocationTable() {
  const history = useHistory();

  const { additionalLocationState } = useMastersContext();

  useEffect(() => {
    additionalLocationState.fetch();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => additionalLocationState.data || [], [
    additionalLocationState.data,
  ]);

  const removeAdditionalLocation = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
      const result = await additionalLocationService.remove(id);
      if (result.success === true) {
        additionalLocationState.fetch();
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Additional Locations</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => history.push("/masters/additional-locations/add")}
          >
            Add New
          </button>
        </div>
      </div>
      <hr />
      <CrudTable
        loading={additionalLocationState.loading}
        data={data}
        columns={columns}
        idField="alrC_ID"
        onEdit={(id) =>
          history.push(`/masters/additional-locations/edit/${id}`)
        }
        onRemove={(id) => removeAdditionalLocation(id)}
      />
    </div>
  );
}

export default AdditionalLocationTable;
